// @ts-nocheck
import React from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useLiveSheet } from "@/components/live-sheets/useLiveSheet";
import EmailGate from "@/components/live-sheets/EmailGate";
import SheetLockScreen from "@/components/live-sheets/SheetLockScreen";
import SheetView from "@/components/live-sheets/SheetView";
import { SheetScope, columnsForScope } from "@/lib/liveSheets";

interface Props {
  scope: SheetScope;
  tokenOverride?: string;
  embedded?: boolean;
}

export default function SheetPageContainer({ scope, tokenOverride, embedded = false }: Props) {
  const params = useParams<{ token: string }>();
  const token = tokenOverride ?? params.token;

  const {
    data,
    loading,
    error,
    needsGate,
    onGatePassed,
    refetch,
    presence,
    permission,
    allowedEmails,
  } = useLiveSheet(scope, token);

  if (loading) {
    return (
      <div className={`flex items-center justify-center text-muted-foreground ${embedded ? "py-12" : "h-screen"}`}>
        <Loader2 className="mr-2 h-5 w-5 animate-spin" /> Loading sheet…
      </div>
    );
  }

  if (error || !data) {
    return <SheetLockScreen message={error || undefined} />;
  }

  if (needsGate) {
    return (
      <EmailGate
        allowedEmails={allowedEmails || []}
        eventName={data?.event?.name}
        onPassed={onGatePassed}
      />
    );
  }

  const columns = columnsForScope(scope, !!data?.show_checkin);

  return (
    <SheetView
      scope={scope}
      token={token}
      data={data}
      columns={columns}
      idField="id"
      permission={permission || "view"}
      presence={presence}
      refetch={refetch}
      showNotes={scope === "event"}
      showSummary={scope === "event" || scope === "payment"}
      embedded={embedded}
    />
  );
}
